import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { actions } from 'store';
import { defaultTheme } from 'styles';
import { themes as readerBuiltInThemes } from 'lib/reader/themes';
import { ModalButtonWithForm } from 'components/common';
import { FormGroup, Text } from 'components/common/form';

export default connect((state) => state)(
  class extends Component {
    handleModalVisible = () => {
      this.titleInputContainer.querySelector('input').focus();
    };

    submit = async (values) => {
      const { dispatch, messages, type, updateThemes } = this.props;

      const { logo, ...defaultSiteData } = defaultTheme;

      const defaultDataForCustomSiteTheme = {
        ...defaultSiteData,
        headerButtonBackgroundColor: '#f2f2f2',
        headerButtonBackgroundColorHover: '#eaeaea',
        headerIconColor: '#6f6f6f',
        headerTextColor: '#333',
        lightGrey: '#f2f2f2',
        lightGreyActive: '#eaeaea',
        lightGreyDark: '#e8e8e8',
        lightGreyDarkActive: '#e2e2e2',
        lightGreyLighter: '#f7f7f7',
        loginBackgroundColor: '#f7f7f7',
        pageBackgroundColor: '#f7f7f7',
        pageIconTextColor: '#333',
        pageIconTextColorLighter: '#6f6f6f',
        pageTextColor: '#333',
        pageTextColorLighter: '#6f6f6f',
        textColor: '#333',
        textColorLight: '#555',
        textColorLighter: '#6f6f6f'
      };

      const defaultDataForCustomReaderTheme = {
        ...readerBuiltInThemes.blue,
        backgroundColor: '#f7f7f7'
      };

      await api.post('/admin/server-themes', {
        title: values.title,
        type: type,
        data:
          type === 'reader'
            ? defaultDataForCustomReaderTheme
            : defaultDataForCustomSiteTheme
      });
      await updateThemes();
      dispatch(
        actions.addNotice({
          text: messages.siteThemesAddSuccess,
          type: 'success'
        })
      );
    };

    render() {
      const { messages } = this.props;
      return (
        <ModalButtonWithForm
          buttonCategory="success"
          buttonIcon="plus"
          buttonText={messages.siteThemesAdd}
          modalActionText={messages.commonAdd}
          modalTitle={messages.siteThemesAdd}
          onModalVisible={this.handleModalVisible}
          onSubmit={this.submit}
          pristineIsValid={false}
        >
          {(formState) => (
            <FormGroup htmlFor="title" label={messages.commonTitle}>
              <Text
                field="title"
                id="title"
                inputContainerRef={(el) => (this.titleInputContainer = el)}
              />
            </FormGroup>
          )}
        </ModalButtonWithForm>
      );
    }
  }
);
